/**
 * CollabCore 全局 CRUD 字典（对标 cool-admin plugins/crud/config.ts）
 */

export const dict = {
  /** 六接口方法名（拼接到 URL 路径末尾） */
  api: {
    list: 'list',
    add: 'add',
    update: 'update',
    delete: 'delete',
    info: 'info',
    page: 'page',
  },
  /** 分页请求体字段名 */
  pagination: {
    page: 'page',
    size: 'size',
  },
  /** 关键字搜索字段名 */
  search: {
    keyWord: 'keyWord',
  },
  /** 排序：order 为排序字段名，sort 为 asc / desc */
  sort: {
    field: 'order',
    direction: 'sort',
  },
  /** 主键字段名 */
  primaryId: 'id',
} as const

export default dict
